module.exports = __webpack_public_path__ + "static/media/appstore-2a.1e6b0a04.png";